module.exports = "<div class=\"accordion\">\n\t<h5 class=\"accordion-header filter-header\">\n\t\t<span data-bind=\"text: title\"></span>\n\t\t<span class=\"accordion-header-icon\"></span>\n\t</h5>\n\t<div class=\"accordion-content filter-content\" data-bind=\"template: {nodes: $componentTemplateNodes, data: data}\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/filters/filter-block.html
// module id = LakT
// module chunks = 8 9